

export function boxMenuFirmy_mouseIn(event) {
	$w("#boxMenuFirmy").show();
	$w("#supportBox").hide(); 
}

export function boxMenuFirmy_mouseOut(event) {
	$w("#boxMenuFirmy").hide();
}

export function boxMenuInfo_mouseIn(event) {
	$w("#boxMenuInfo").show();
	$w("#supportBox").hide(); 
}

export function boxMenuInfo_mouseOut(event) {
	$w("#boxMenuInfo").hide();
}

export function boxMenuDomacnosti_mouseIn(event) {
	$w("#boxMenuDomacnosti").show();
	$w("#supportBox").hide(); 
}

export function boxMenuDomacnosti_mouseOut(event) {
	$w("#boxMenuDomacnosti").hide();
}

export function boxMenuFirmy_mouseIn_1(event) {
	$w("#boxMenuFirmy").show();
	$w("#supportBox").hide(); 
}

export function boxMenuFirmy_mouseOut_1(event) {
	$w("#boxMenuFirmy").hide();
}

export function boxMenuInfo_mouseIn_1(event) {
	$w("#boxMenuInfo").show();
	$w("#supportBox").hide(); 
}

export function boxMenuInfo_mouseOut_1(event) {
	$w("#boxMenuInfo").hide();
}

export function boxMenuFirmy_mouseIn_2(event) {
	$w("#boxMenuFirmy").show();
	$w("#supportBox").hide(); 
}

export function boxMenuFirmy_mouseOut_2(event) {
	$w("#boxMenuFirmy").hide();
}
